import React from 'react';

const Directory = () => {
  return <h2>Hi! I'm a React Component!</h2>;
};
export default Directory;
